import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  selectedLPSharedUid: "",
  selectedLPAccount: "",
  selectedLPDateRange: [],
  selectedLPCampaign: "",
  allAdvertisingAccounts: [], // This will hold all advertising accounts
  relevantAccountsBasedOnSite: [], // This will hold accounts relevant to the current site
  allCampaigns: [], // This will hold all campaigns
  costWeightChartData: [],
  performanceByKeywords: [],
  lpLoader: false,
  keywordDetailsByInternalId: [],
  singleKeywordDetails: [],
  page: 0,
  rowsPerPage: 5,
  sort: {
    keytoSort: "",
    direction: "desc",
  },
  pageTopKeyword: 0,
  rowsPerPageTopKeyword: 5,
  sortTopKeyword: {
    keytoSort: "",
    direction: "desc",
  },
  siteDimensions: [],
  dailyLPExperienceDetails: [],
  competitorMetricsAccordionDetails: [],
  pageSpeedMetricsDetails: [],
  engagementMetricsDetails: [],
  urlKeywordsLoading: false,
  keywordsLinkedToURL: [],
  keywordReleventScore: [],
  keywordReleventScoreLoading: false,
  pageSpeedMetricsLoading: false,
};

const landingPageExperienceSlice = createSlice({
  name: "landingPageExperience",
  initialState,
  reducers: {
    setSelectedLPSharedUid: (state, action) => {
      state.selectedLPSharedUid = action.payload;
    },
    setSelectedLPAccount: (state, action) => {
      state.selectedLPAccount = action.payload;
    },
    setSelectedLPDateRange: (state, action) => {
      state.selectedLPDateRange = action.payload;
    },
    setSelectedLPCampaign: (state, action) => {
      state.selectedLPCampaign = action.payload;
    },
    setAllAdvertisingAccounts: (state, action) => {
      state.allAdvertisingAccounts = action.payload;
    },
    setRelevantAccountsBasedOnSite: (state, action) => {
      state.relevantAccountsBasedOnSite = action.payload;
    },
    setAllCampaigns: (state, action) => {
      state.allCampaigns = action.payload;
    },
    setCostWeightchartData: (state, action) => {
      state.costWeightChartData = action.payload;
    },
    setPerformanceByKeywords: (state, action) => {
      state.performanceByKeywords = action.payload;
    },
    setLpLoader: (state, action) => {
      state.lpLoader = action.payload;
    },
    setKeywordDetailsByInternalId: (state, action) => {
      state.keywordDetailsByInternalId = action.payload;
    },
    setSingleKeywordDetails: (state, action) => {
      state.singleKeywordDetails = action.payload;
    },
    setPage: (state, action) => {
      state.page = action.payload;
    },
    setRowsPerPage: (state, action) => {
      state.rowsPerPage = action.payload;
    },
    setSort: (state, action) => {
      state.sort = action.payload;
    },
    setPageTopKeyword: (state, action) => {
      state.pageTopKeyword = action.payload;
    },
    setRowsPerPageTopKeyword: (state, action) => {
      state.rowsPerPageTopKeyword = action.payload;
    },
    setSortTopKeyword: (state, action) => {
      state.sortTopKeyword = action.payload;
    },
    setSiteDimensions: (state, action) => {
      state.siteDimensions = action.payload;
    },
    resetStateOfLP: () => initialState, // reset everything
    setDailyLPExperienceDetails: (state, action) => {
      state.dailyLPExperienceDetails = action.payload;
    },
    setCompetitorMetricsAccordionDetails: (state, action) => {
      state.competitorMetricsAccordionDetails = action.payload;
    },
    setPageSpeedMetricsDetails: (state, action) => {
      state.pageSpeedMetricsDetails = action.payload;
    },
    setEngagementMetricsDetails: (state, action) => {
      state.engagementMetricsDetails = action.payload;
    },
    setUrlKeywordsLoading: (state, action) => {
      state.urlKeywordsLoading = action.payload;
    },
    setKeywordsLinkedToURL: (state, action) => {
      state.keywordsLinkedToURL = action.payload;
    },
    setKeywordReleventScore: (state, action) => {
      state.keywordReleventScore = action.payload;
    },
    setKeywordReleventScoreLoading: (state, action) => {
      state.keywordReleventScoreLoading = action.payload;
    },
    setPageSpeedMetricsLoading: (state, action) => {
      state.pageSpeedMetricsLoading = action.payload;
    },
  },
});

export const {
  setSelectedLPSharedUid,
  setSelectedLPAccount,
  setSelectedLPDateRange,
  setSelectedLPCampaign,
  setAllAdvertisingAccounts,
  setRelevantAccountsBasedOnSite,
  setAllCampaigns,
  setCostWeightchartData,
  setPerformanceByKeywords,
  setLpLoader,
  setKeywordDetailsByInternalId,
  setSingleKeywordDetails,
  setPage,
  setRowsPerPage,
  setSort,
  setPageTopKeyword,
  setRowsPerPageTopKeyword,
  setSortTopKeyword,
  setSiteDimensions,
  resetStateOfLP,
  setDailyLPExperienceDetails,
  setCompetitorMetricsAccordionDetails,
  setPageSpeedMetricsDetails,
  setUrlKeywordsLoading,
  setKeywordsLinkedToURL,
  setKeywordReleventScore,
  setKeywordReleventScoreLoading,
  setPageSpeedMetricsLoading,
  setEngagementMetricsDetails,
} = landingPageExperienceSlice.actions;

export default landingPageExperienceSlice.reducer;
